export const SET_AUTOCONFIRMATION_ORDER = 'SET_AUTOCONFIRMATION_ORDER'
export const SET_AUTOCONFIRMATION_ERROR = 'SET_AUTOCONFIRMATION_ERROR'
